import { FeatureDomain } from '@akin-home/amplify';
import { pickAttributes } from '@akin-home/objects';
import { showSuccessToast } from '@akin-home/toast/native';
import { sendBackgroundMessage } from '../../chat/functions';
import { postUpdateRecordLogEvent } from '../../logging/functions';
import { getCurrentUserID } from '../../users/functions';
import { CalendarItemUnion } from '../types';

type Params = {
  item: CalendarItemUnion;
};

export const afterUpdateCalendarItem = ({ item }: Params) => {
  const { type } = item;
  const { trigger, context } = getInfo(item);

  sendBackgroundMessage(trigger, { context });

  postUpdateRecordLogEvent({
    user_id: getCurrentUserID() as string,
    feature_domain: FeatureDomain.CALENDAR,
    data: {
      id: item.id,
      model: type || 'Calendar Item',
    },
  });

  showSuccessToast({
    text1: 'Success!',
    text2: `${type || 'Event'} Updated`,
  });
};

const getInfo = (item: CalendarItemUnion) => {
  const data = pickAttributes(item, ['id', 'title', 'emoji']);
  const start = item.start.toISOString();

  if (item.type === 'Event') {
    return {
      trigger: 'updated_event',
      context: {
        event: {
          ...data,
          start,
          end: item.end.toISOString(),
        },
      },
    };
  } else if (item.type === 'Alert') {
    return {
      trigger: 'updated_alert',
      context: {
        alert: {
          ...data,
          start,
        },
      },
    };
  } else {
    return {
      trigger: 'updated_alarm',
      context: {
        alarm: {
          ...data,
          start,
        },
      },
    };
  }
};
